import { createFileRoute } from '@tanstack/react-router'
import { SmtpSettingsPage } from '@/features/admin/smtp'
import { requireRole } from '@/lib/auth-guards'

export const Route = createFileRoute('/_authenticated/smtp/')({
  component: SmtpSettingsPage,
  beforeLoad: requireRole(['admin']),
})
